var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6642 14.8454L8.05153 6.79271C8.983 5.04954 8.75011 2.81373 7.35296 1.33582C5.66919 -0.445275 2.94657 -0.445275 1.26283 1.33582C-0.420943 3.11693 -0.420943 5.99691 1.26283 7.77798C2.65998 9.25589 4.77361 9.50224 6.42153 8.51693L10.2368 12.5528L9.01885 13.8411C8.83968 14.0306 8.83968 14.3527 9.01885 14.5421L9.8786 15.4516C10.0578 15.6411 10.3623 15.6411 10.5413 15.4516L11.7593 14.1632L12.5116 14.959L11.2936 16.2474C11.1145 16.4369 11.1145 16.759 11.2936 16.9484L12.1534 17.8579C12.3326 18.0474 12.637 18.0474 12.8161 17.8579L14.0341 16.5695C14.4819 17.0432 15.2163 17.0432 15.6641 16.5695C16.1119 16.0961 16.112 15.3191 15.6642 14.8454ZM4.20042 4.46216C3.73474 4.95477 2.96445 4.95477 2.4988 4.46216C2.03312 3.96956 2.03312 3.15475 2.4988 2.66218C2.96448 2.16958 3.73477 2.16958 4.20042 2.66218C4.68395 3.15479 4.68395 3.95055 4.20042 4.46216Z",
    fill: "#505762"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.59bb11b87303891e5e8bec0916a9fc57.svg";
export { ForwardRef as ReactComponent };